// src/app/httpClient.ts
import { fetchUtils } from "react-admin";
import type { RequestOptions } from "./types/api";
import { API_BASE_URL } from "./config";

export const httpClient: typeof fetchUtils.fetchJson = (
  url: string,
  options: RequestOptions = {},
) => {
  const token = localStorage.getItem("tn_admin_access");
  options.headers = new Headers(
    options.headers || { Accept: "application/json" },
  );
  if (token) {
    (options.headers as Headers).set("Authorization", `Bearer ${token}`);
  }
  // Remove credentials to avoid CORS issues with wildcard origin
  // options.credentials = "include";
  return fetchUtils.fetchJson(url, options);
};

// Build every API URL from the centralized base URL.
export const apiUrl = (endpoint: string): string =>
  `${API_BASE_URL}/${endpoint.replace(/^\/+/, "")}`;
